<template>
  <v-data-table
    :headers="headers"
    :items="phases"
    sort-by="model"
    class="elevation-1 dark-last-row"
    hide-default-footer
    :loading="loading"
    items-per-page="500"
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="#003a6f"
      >
        <v-toolbar-title class="white--text">Phases</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              tile
              small
            >
              <v-icon dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>
          <v-card flat color="#004889">
            <v-card-title class="accent">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

           <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="warrantyform">
                  <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Title</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Title" rules="required">
                              <v-text-field
                                v-model="editedItem.title"
                                label="Title"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Job Type</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Contract Type" rules="required">
                                <v-select
                                    v-model="editedItem.job_type"
                                    :items="job_types"
                                    item-text="title"
                                    item-value="id"
                                    label="Contract Type"
                                    required
                                    :error-messages="errors"
                                    solo
                                    flat
                                    dark
                                ></v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn large min-width="50%" color="primary" tile @click="editItem(item)">      
        <v-icon
        >
          mdi-pencil
        </v-icon>
      </v-btn>             
      <v-btn large min-width="50%" color="red" tile @click="deleteItem(item.id)">
        <v-icon
        color="white"
        >
        mdi-delete
      </v-icon>  
      </v-btn>  
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="getEquipment"
        tile
        :loading="loading"
      >
        No Items Found. Click Here to Refresh!
      </v-btn>
    </template>
    <template v-slot:item.job_type="{ item }">
      <span>{{ getJobType(item.job_type) }}</span>
    </template>
  </v-data-table>
</template>

<script>
    import axios from 'axios'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import { mapGetters } from 'vuex'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        data: () => ({
            loading: false,
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Phase Title', value: 'title', sortable: false },
                { text: 'Job Type', value: 'job_type', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            phases: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                title: '',
            },
            defaultItem: {
                id: '',
                title: '',
            },
        }),

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        computed: {
            ...mapGetters({
              job_types: 'data/job_types'
            }),
            formTitle () {
                return this.editedIndex === -1 ? 'New Phase' : 'Edit Phase'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
            this.getPhases()
        },

        methods: {
            getPhases() {
                this.loading = true
                axios.get('crm/job/phase/get')
                    .then(response => {
                        this.loading = false
                        this.phases = response.data
                        this.$nextTick()
                    })
            },

            editItem (item) {
                this.editedIndex = this.phases.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (id) {
                this.editedIndex = id
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.loading = true
                axios.delete('crm/job/phase/delete?id=' + this.editedIndex)
                    .then(() => {
                      this.closeDelete()
                      this.getPhases()
                      this.$nextTick()
                    })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            async save () {
                if (this.editedIndex > -1) {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('crm/job/phase/update', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getPhases()
                          this.close()
                      }).catch(error => {
                          console.log(error)
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                } else {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('crm/job/phase/add', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getPhases()
                          this.close()
                      }).catch(error => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                }
            },
            getJobType(id) {
              let job_types = this.job_types.filter(job => {
                return job.id == id
              })

              if(job_types.length)
                return job_types[0].title
            }
        },
    }
</script>